export function getValueOrDefault<T>(
  value: T | null | undefined,
  defaultValue: T | string = ''
): T | string {
  return value ?? defaultValue;
}
